import { render } from "./github.vue?vue&type=template&id=853015ac&scoped=true"
import script from "./github.vue?vue&type=script&lang=js"
export * from "./github.vue?vue&type=script&lang=js"

import "./github.vue?vue&type=style&index=0&id=853015ac&lang=scss&scoped=true"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-853015ac"]])

export default __exports__